import React from 'react';
import { Stack } from '@99designs/emu';
import { CurrencyCode } from '@99designs/i18n';
import * as Field from '../Field';
import { BriefOverviewFragment } from './BriefOverview.generated';
import { ViewFieldHeading } from './ViewFieldHeading';

export interface BriefOverviewProps {
    brief: BriefOverviewFragment;
    excludedQuestions?: string[];
}

// Project briefs on 99designs do not currently support ClientConfiguredField nor WorkEntityField questions.
// At this point in time, such questions are only available for `libs/feature-design-services-brief`.
export function BriefOverview({ brief, excludedQuestions }: BriefOverviewProps) {
    return (
        <Stack space="1.5bu">
            {brief.dynamicFields
                .filter(
                    (f) =>
                        Field.hasValue({ ...f, briefId: brief.id }) &&
                        f.__typename !== 'ClientConfiguredField' &&
                        f.__typename !== 'WorkEntityField' &&
                        !excludedQuestions?.includes(f.label)
                )
                .map(
                    (field) =>
                        field.__typename !== 'ClientConfiguredField' &&
                        field.__typename !== 'WorkEntityField' && (
                            <Stack space={'0.25bu'} key={field.id}>
                                <ViewFieldHeading>{field.label}</ViewFieldHeading>
                                <Field.View
                                    {...field}
                                    briefId={brief.id}
                                    currency={brief.currency as CurrencyCode}
                                    category={brief.category}
                                />
                            </Stack>
                        )
                )}
        </Stack>
    );
}
